import { ENTERPRISE_ADLE_MODULE_VALUES } from "../../../utils/constants";

const {
  CREATIVE_ASSETS,
  PAID_MEDIA_LAUNCH,
  PAID_MEDIA_IMPORT,
  ORGANIC_SOCIAL,
} = ENTERPRISE_ADLE_MODULE_VALUES;

export const ENTERPRISE_INTAKE_RELOCATED_FIELDS = {
  hasAdminAccessPhase1: PAID_MEDIA_LAUNCH,
  phase1PaidChannels: PAID_MEDIA_LAUNCH,
  monthlyAdSpendRange: PAID_MEDIA_LAUNCH,
};

export const ENTERPRISE_INTAKE_MODULE_REQUIRED_NUMERIC = {
  [CREATIVE_ASSETS]: [
    "module1BrandsOrVisualIdentitiesCount",
    "module1IndependentBrandConfigsCount",
    "module1MonthlyNewImagesCount",
    "module1FormatsPerPieceAvg",
    "module1MonthlyVideosCount",
    "module1MonthlyImageAnimationsCount",
    "module1VersionsPerPieceBeforeApproval",
  ],
  [PAID_MEDIA_LAUNCH]: [
    "module2AdAccountsOrAdvertisersCount",
    "module2MonthlyCampaignsCount",
    "module2MonthlyOptimizationsCount",
  ],
  [PAID_MEDIA_IMPORT]: ["module3CampaignsToImportCount"],
  [ORGANIC_SOCIAL]: ["module4MonthlyOrganicPostsCount"],
};

export const ENTERPRISE_INTAKE_MODULE_OPTIONAL_NUMERIC = {
  [CREATIVE_ASSETS]: ["module1MonthlyAdditionalEditsCount"],
};

export const ENTERPRISE_INTAKE_MODULE_REQUIRED_RADIO = {
  [CREATIVE_ASSETS]: ["module1CreativeVolumeVariation"],
  [PAID_MEDIA_LAUNCH]: [
    "monthlyAdSpendRange",
    "hasAdminAccessPhase1",
    "module2CampaignVolumeVariation",
  ],
  [ORGANIC_SOCIAL]: ["module4PostCreationSource"],
};

export const ENTERPRISE_INTAKE_MODULE_REQUIRED_CHECKBOX = {
  [PAID_MEDIA_LAUNCH]: ["phase1PaidChannels"],
  [PAID_MEDIA_IMPORT]: ["module3ImportPlatforms"],
  [ORGANIC_SOCIAL]: ["module4SchedulingNetworks"],
};

export const ENTERPRISE_INTAKE_MODULE_PEAK_PAIRS = [
  {
    module: CREATIVE_ASSETS,
    variationField: "module1CreativeVolumeVariation",
    peakField: "module1PeakMonthPiecesCount",
  },
  {
    module: PAID_MEDIA_LAUNCH,
    variationField: "module2CampaignVolumeVariation",
    peakField: "module2PeakMonthCampaignsCount",
  },
];

export const ENTERPRISE_INTAKE_BASE_RADIO_OTHER_PAIRS = [
  ["primaryGoal", "primaryGoalOther"],
  ["currentToolOrAdleStatus", "currentToolOrAdleStatusOther"],
  ["creditsManagementModel", "creditsManagementModelOther"],
];

export const ENTERPRISE_INTAKE_MODULE_RADIO_OTHER_PAIRS = [
  ["hasAdminAccessPhase1", "hasAdminAccessPhase1Other"],
  ["monthlyAdSpendRange", "monthlyAdSpendRangeOther"],
];

export const ENTERPRISE_INTAKE_MODULE_CHECK_OTHER_PAIRS = [
  ["phase1PaidChannels", "phase1PaidChannelsOther"],
  ["module3ImportPlatforms", "module3ImportPlatformsOther"],
  ["module4SchedulingNetworks", "module4SchedulingNetworksOther"],
];

export const ENTERPRISE_INTAKE_MODULE_RADIO_OTHER_BY_MODULE = {
  [PAID_MEDIA_LAUNCH]: ENTERPRISE_INTAKE_MODULE_RADIO_OTHER_PAIRS,
};

export const ENTERPRISE_INTAKE_MODULE_CHECK_OTHER_BY_MODULE = {
  [PAID_MEDIA_LAUNCH]: [["phase1PaidChannels", "phase1PaidChannelsOther"]],
  [PAID_MEDIA_IMPORT]: [
    ["module3ImportPlatforms", "module3ImportPlatformsOther"],
  ],
  [ORGANIC_SOCIAL]: [
    ["module4SchedulingNetworks", "module4SchedulingNetworksOther"],
  ],
};
